module.exports = __webpack_public_path__ + "img/getstarted_create.fa01440d.gif";